var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    [
      _c("el-button", {
        staticStyle: { "margin-bottom": "10px" },
        attrs: { icon: "el-icon-plus", circle: "", size: "mini" },
        on: { click: _vm.addThreshold },
      }),
      _c(
        "div",
        { staticStyle: { "max-height": "50vh", "overflow-y": "auto" } },
        _vm._l(_vm.thresholdArr, function (item, index) {
          return _c(
            "el-row",
            { key: index, staticClass: "line-item" },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "mini" },
                      on: { change: _vm.changeThreshold },
                      model: {
                        value: item.term,
                        callback: function ($$v) {
                          _vm.$set(item, "term", $$v)
                        },
                        expression: "item.term",
                      },
                    },
                    _vm._l(_vm.valueOptions, function (group, idx) {
                      return _c(
                        "el-option-group",
                        { key: idx, attrs: { label: group.label } },
                        _vm._l(group.options, function (opt) {
                          return _c("el-option", {
                            key: opt.value,
                            attrs: { label: opt.label, value: opt.value },
                          })
                        }),
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { span: 14 },
                },
                [
                  item.term !== "between"
                    ? _c("el-input", {
                        staticClass: "value-item",
                        attrs: {
                          placeholder: _vm.$t("chart.drag_block_label_value"),
                          size: "mini",
                          clearable: "",
                        },
                        on: { change: _vm.changeThreshold },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      })
                    : _vm._e(),
                  item.term === "between"
                    ? _c(
                        "span",
                        [
                          _c("el-input", {
                            staticClass: "between-item",
                            attrs: {
                              placeholder: _vm.$t("chart.axis_value_min"),
                              size: "mini",
                              clearable: "",
                            },
                            on: { change: _vm.changeThreshold },
                            model: {
                              value: item.min,
                              callback: function ($$v) {
                                _vm.$set(item, "min", $$v)
                              },
                              expression: "item.min",
                            },
                          }),
                          _c("span", { staticStyle: { margin: "0 4px" } }, [
                            _vm._v(
                              "≤" +
                                _vm._s(_vm.$t("chart.drag_block_label_value")) +
                                "≤"
                            ),
                          ]),
                          _c("el-input", {
                            staticClass: "between-item",
                            attrs: {
                              placeholder: _vm.$t("chart.axis_value_max"),
                              size: "mini",
                              clearable: "",
                            },
                            on: { change: _vm.changeThreshold },
                            model: {
                              value: item.max,
                              callback: function ($$v) {
                                _vm.$set(item, "max", $$v)
                              },
                              expression: "item.max",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "text-align": "center" }, attrs: { span: 2 } },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                    on: { change: _vm.changeThreshold },
                    model: {
                      value: item.color,
                      callback: function ($$v) {
                        _vm.$set(item, "color", $$v)
                      },
                      expression: "item.color",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c("el-button", {
                    staticStyle: { float: "right" },
                    attrs: { type: "text", icon: "el-icon-delete", circle: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeThreshold(index)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }